<!-- 加载中 -->
<template>
  <div
    v-show="show"
    class="loading_wrap"
  >
    <van-loading
      class="loading_spinner"
      type="spinner"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import { Loading, Popup } from 'vant'
Vue.use(Loading)
Vue.use(Popup)

export default {
  name: 'CusLoading',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    show: {
      handler(val) {
        if (val) {
          document.documentElement.style.overflow = 'hidden';
          document.body.style.overflow = 'hidden';
        } else {
          document.documentElement.style.overflow = 'auto';
          document.body.style.overflow = 'auto';
        }
      },
      immediate: true

    }
  },
  data() {
    return {

    };
  },

  components: {},

  methods: {

  },

  mounted() {

  },
}
</script>
<style lang='less' scoped>
.loading_wrap {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: rgba(255, 255, 255, 1);
}
.loading_spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  color: #06f;
}
</style>